<template>
    <form @keyup.enter="saveBtn">
        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card  >

            <div class="modal-card ">
                <section class="modal-card-body"  >

                    <template>
<!--                     {{ JSON.stringify(dataToChild)}}-->

                        <b-field label="Name"
                                 :type="{ 'is-danger': hasRequire }"
                                 :message= "{ 'This field is require' : hasRequire }">
                            <b-input v-model="nameModel" ></b-input>
                        </b-field>

                        <b-field label="Status">
                            <b-switch v-model="dataToChild.status">
                               {{ statusModel}}
                            </b-switch>
                        </b-field>



                    </template>

                </section>
                <footer class="modal-card-foot">

                                <b-button size="is-medium" type="is-success"
                                          icon-left="content-save" @click="saveBtn"  >
                                    Save
                                </b-button>



                                <b-button size="is-medium" type="is-danger"
                                          icon-left="close" @click="closeBtn"  >
                                    Close
                                </b-button>

                </footer>
            </div>

        </b-modal>
    </form>
</template>

<script>
    /* eslint-disable no-console */
    import { required} from 'vuelidate/lib/validators'
    import axios from "axios"
    import { getBaseURLforBackEnd  , getConfigAxios  }  from '@/utils.js'
    // required
    export default {
        name: "AddEditAuthGroup",
        props:{
          dataToChild : Object,
        },

        computed:{
          statusModel:{
              get(){
                  return   this.dataToChild.status ? 'ใช้งาน' : 'ยกเลิก'
              },
          }  ,
          nameModel :{
              get(){
                return   this.dataToChild.name
              },
              set(value){
                  this.dataToChild.name = value
              }
          }
        },
        validations:{
            nameModel :{
               required
            },
        },
        methods:{
            saveBtn(){
               if(  this.dataToChild.name.trim().length === 0 ){
                  this.hasRequire = true
                   return
               }

               // if pass
               //**********************************************
               //**********************************************
               // insert action
               //**********************************************
               if(this.dataToChild.mode==='insert') {
                   const vm = this
                   const datTo =  {
                       "name" :  this.nameModel  ,
                       "enable" : this.statusModel
                   }
                   this.isFullScreenLoading = true
                   axios.post(`${getBaseURLforBackEnd()}/api/addauthgroup`,datTo,getConfigAxios())
                       .then(()=>{
                           vm.isFullScreenLoading = false
                           vm.closeBtn()
                           vm.$buefy.toast.open({
                               message: 'Add New Complete',
                               type: 'is-success'
                           })
                       })
                       .finally(()=>{
                           vm.isFullScreenLoading = false
                       })
                       .catch((err)=>{
                           vm.isFullScreenLoading = false
                           vm.$buefy.toast.open({
                               message: `${err} something goes wrong!!!`,
                               type: 'is-danger'
                           })
                       })

               }
                //**********************************************
                //**********************************************
                // edit action
                //**********************************************
                if(this.dataToChild.mode==='edit') {
                    const vm = this
                    const datTo =  {
                        "name" :  this.nameModel  ,
                        "id" : this.dataToChild.id,
                        "enable" : this.dataToChild.status
                    }
                    this.isFullScreenLoading = true
                    axios.post(`${getBaseURLforBackEnd()}/api/editauthgroup`,datTo,getConfigAxios())
                        .then(()=>{
                            vm.isFullScreenLoading = false
                            vm.closeBtn()
                            vm.$buefy.toast.open({
                                message: 'Update Complete',
                                type: 'is-success'
                            })
                        })
                        .finally(()=>{
                            vm.isFullScreenLoading = false
                        })
                        .catch((err)=>{
                            vm.isFullScreenLoading = false
                            vm.$buefy.toast.open({
                                message: `${err} something goes wrong!!!`,
                                type: 'is-danger'
                            })
                        })

                }

            },
            closeBtn(){
                this.isComponentModalActive = false
                this.$emit('close')
            }
        },
        data(){
            return{
                isComponentModalActive : false,
                hasRequire : false
            }
        },
        watch:{
            nameModel : function (val) {
               if(val.trim().length === 0){
                   this.hasRequire = true
               }else{
                   this.hasRequire = false
               }

            },
            isComponentModalActive: function (val) {
                if(val){
                    if(this.dataToChild.mode === 'insert'){
                        this.hasRequire = false
                    }
                }

            }

        }

    }
</script>

<style scoped>

</style>